import {
  Autocomplete,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import CustomInput from "../Form/CustomInput";
import CustomImageShow from "../Form/CustomImageShow";
import { memo, useCallback, useEffect, useMemo, useState } from "react";
// import RestartAltIcon from "@mui/icons-material/RestartAlt";
import CustomButton from "../Form/CustomButton";
import { axiosPrivate } from "../../api/axios/axios";
import { toast } from "react-toastify";
import LineChart from "../Form/lineChart";
import { useNavigate } from "react-router-dom";
// import PercentIcon from "@mui/icons-material/Percent";
import "./CreateForm.css"; // Import the CSS file
// import TelegramIcon from "@mui/icons-material/Telegram";
// import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import io from "socket.io-client";

import AppConstants from "../../AppConstrains/AppConstrains";
// import useAxiosPrivate from "../../Hooks/useAxiosPrivate";
// import ActiveButton from "../User/ActiveButton";
import axios from "../../api/axios/axios";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import Quill CSS
import { hasVisibleText } from "../../utils/hasVisibleText";
// import keys from "../../../../backend/config/keys";
const socket = io(AppConstants.baseURL, {
  path: "/api/thebestdeals/socket.io",
  transports: ["websocket"],
});
socket.on("connect", () => console.log("Connected!"));
socket.on("message", (data) => console.log("Message from server:", data));
socket.on("connect_error", (err) => console.error("Connection Error:", err));

const CreateForm = memo(
  ({ dealsData = {}, setLink, rowData = null, isDeal, isMessage }) => {
    const graph_data = dealsData?.graph_data;
    // const axiosPrivate = useAxiosPrivate();
    const [stores, setStores] = useState([]);
    const [categories, setCategories] = useState([]);
    const [CreateData, setCreateData] = useState({
      tbd_deal_type: isDeal ? 2 : isMessage ? 3 : undefined,
    });

    const [isConnected, setIsConnected] = useState(false);

    const [selectedCategories, setSelectedCategories] = useState([]);

    const [selectedStores, setSelectedStores] = useState([]);
    const [isQuillFocused, setIsQuillFocused] = useState(false);

    const navigate = useNavigate();
    const handelChange = (event) => {
      setCreateData({ ...CreateData, [event.target.name]: event.target.value });
    };

    const handleQuillChange = (value) => {
      const isValid = hasVisibleText(value);
      const finalValue = isValid ? value : null;

      setCreateData((prev) => ({ ...prev, text: finalValue }));
    };

    // const sendDealsApp = (e) => {
    //   e.preventDefault();
    //   socket.emit("deals", CreateData);
    //   if (isConnected) {
    //     console.log("connected");
    //   } else {
    //     toast.error("Socket not connected");
    //   }
    // };
    useEffect(() => {
      // Listen for connection status
      socket.on("connection", () => {
        console.log("Socket connected");
        setIsConnected(true); // Update connection status
      });

      socket.on("disconnect", () => {
        console.log("Socket disconnected");
        setIsConnected(false); // Update connection status
      });

      // Clean up the socket connection on component unmount
      return () => {
        socket.off("connection");
        socket.off("disconnect");
      };
    }, []);

    useEffect(() => {
      const fetchStores = async () => {
        const response = await axios.get(
          "https://flipshope.com/api/prices/graphactivestores"
        );
        const stores = response.data.data.map((store) => ({
          value: parseInt(store.site_id),
          label: store.store_name,
        }));
        console.log(stores, "Stores for message");
        setStores(stores);

        // console.log(response, "response");
      };
      fetchStores();

      const fetchCategories = async () => {
        const response = await axios.get(
          "https://flipshope.com/api/prices/getprodcat"
        );
        const categories = response.data.data.map((category) => ({
          value: category.cat_id,
          label: category.cat_name,
        }));
        setCategories(categories);

        // console.log(response, "response");
      };
      fetchCategories();
    }, []);

    useEffect(() => {
      if (dealsData && Object?.keys(dealsData)?.length > 0) {
        setCreateData({
          ...CreateData,
          _id: dealsData?._id,
          pid: dealsData?.pid,
          sid: dealsData?.sid,
          text: dealsData?.text,
          title: dealsData?.title,
          imgurl: dealsData?.imgurl,
          mrp: dealsData?.mrp,
          active: dealsData?.active,
          category: dealsData?.category,
          sub_category: dealsData?.sub_category,
          brand: dealsData?.brand,
          latestPrice:
            dealsData?.latestPrice?.[0]?.price || dealsData?.latestPrice,
          graph_data: dealsData?.graph_data,
          aff_url: dealsData?.aff_url,
          color: dealsData?.color,
          inStock:
            dealsData?.inStock || dealsData?.latestPrice?.[0]?.inStock || 0,
          tbd_deal_type: dealsData?.tbd_deal_type,
          deal_type_filter: dealsData?.deal_type || 1,
          ...(dealsData?.priority
            ? { priority: parseInt(dealsData.priority) }
            : {}),
          isExpired: dealsData?.isExpired,
          // isSent_app: dealsData?.isSent_app,
        });
        setSelectedCategories(
          Array.isArray(dealsData?.category)
            ? categories.filter((cat) => dealsData.category.includes(cat.value))
            : categories.filter(
                (category) => category.value === dealsData?.category
              )
        );
        setSelectedStores(
          Array.isArray(dealsData?.sid)
            ? stores.filter((store) => dealsData.sid.includes(store.value))
            : stores.filter((store) => store.value === dealsData?.sid)
        );
        // setIsSent_app(dealsData?.isSent_app);

        console.log("Selected Categories");
      }
    }, [dealsData, categories, stores]);

    // useEffect(() => {
    //   setCreateData({
    //     ...CreateData,
    //     isSent_app: isSent_app ? 1 : 0,
    //   });
    // }, [isSent_app]);

    const activeOptions = useMemo(
      () => [
        { value: 0, label: "false" },
        { value: 1, label: "true" },
        // { value: 3, label: "loot Deals" },
      ],
      []
    );

    const DealOptions = useMemo(
      () => [
        { value: 1, label: "Normal Deals" },
        { value: 2, label: "Hot Deals" },
        { value: 3, label: "loot Deals" },
      ],
      []
    );

    const saveToDb = useCallback(
      async (isSend = false) => {
        const CREATE_DATA_URL = "/api/deals/savetodb";
        const UPDATE_DATA_URL = "/api/deals/updateproductdb";

        try {
          let savedData = {};

          // Prepare savedData based on CreateData and your conditions
          savedData = {
            ...(rowData && { _id: CreateData?._id }), // include _id only for update
            pid: CreateData?.pid || null,
            sid: CreateData?.sid?.length === 0 ? null : CreateData?.sid || null,
            text: CreateData?.text || null,
            title: CreateData?.title || null,
            imgurl: CreateData?.imgurl || null,
            mrp: CreateData?.mrp || null,
            // active: CreateData?.active || null,
            category:
              CreateData?.category?.length === 0
                ? null
                : CreateData?.category || null,
            sub_category: CreateData?.sub_category || null,
            brand: CreateData?.brand || null,
            latestPrice:
              CreateData?.latestPrice?.[0]?.price ||
              CreateData?.latestPrice ||
              null,
            graph_data: dealsData?.graph_data || null,
            aff_url: CreateData?.aff_url || null,
            color: CreateData?.color || null,
            inStock:
              CreateData?.inStock || CreateData?.latestPrice?.[0]?.inStock || 0,
            tbd_deal_type:
              CreateData?.tbd_deal_type === 1 ||
              CreateData?.tbd_deal_type === undefined
                ? CreateData?.tbd_deal_type
                : isDeal
                ? 2
                : isMessage
                ? 3
                : null,
            deal_type: CreateData?.deal_type_filter || 1,
            ...(CreateData?.priority
              ? { priority: parseInt(CreateData.priority) }
              : {}),

            // priority: parseInt(CreateData?.priority) || null,
          };

          // console.log("Saved Data", savedData);

          // if (!savedData.imgurl && !savedData.text) {
          //   toast.error(
          //     "Either image URL or text is required. Both fields cannot be empty."
          //   );
          //   return;
          // }

          //+Uncomment API Calls
          if (rowData) {
            const update = await axiosPrivate.put(UPDATE_DATA_URL, {
              ...savedData,
              isSend,
              isExpired: parseInt(CreateData.isExpired),
            });

            toast.success(update.data.message);
            navigate("/viewdeals");
          } else {
            const save = await axiosPrivate.post(CREATE_DATA_URL, savedData);
            toast.success(save.data.msg);
            navigate("/viewdeals");
          }

          //   setCreateData({});
          //   setLink("");
        } catch (error) {
          toast.error(error?.response?.data?.message);
          console.log(error, "error in fetch db");
        }
      },
      [CreateData]
    );

    // console.log(CreateData, "createData");
    // console.log(rowData, "rowData");
    // console.log(dealsData, "dealsData");
    // console.log("create Form", CreateData);

    return (
      <div>
        <Paper
          className="create-form-container"
          // sx={{ display: `${Object.keys(dealsData).length ? "block" : "none"}` }}
        >
          <Typography variant="h5" component="h5" className="form-title">
            {isMessage && "Message"} {isDeal && "Deals"} Details
          </Typography>
          <div className="form-wrapper">
            <div className="form-row md-flex-row">
              {isDeal && (
                <CustomInput
                  label="Pid"
                  name="pid"
                  className="input-grow"
                  value={CreateData.pid}
                  disabled={true}
                />
              )}
              <Autocomplete
                size="small"
                className="w-[50%]"
                multiple
                id="sid"
                options={[{ label: "Select All", value: "all" }, ...stores]}
                disableCloseOnSelect
                value={selectedStores}
                onChange={(event, newValue) => {
                  const isSelectAllSelected = newValue.some(
                    (option) => option.value === "all"
                  );

                  if (isSelectAllSelected) {
                    const allSelected = selectedStores.length < stores.length;
                    const finalSelection = allSelected ? stores : [];

                    setSelectedStores(finalSelection);
                    setCreateData({
                      ...CreateData,
                      sid: finalSelection.map((option) => option.value),
                    });
                  } else {
                    setSelectedStores(newValue);
                    setCreateData({
                      ...CreateData,
                      sid: newValue.map((option) => option.value),
                    });
                  }
                }}
                getOptionLabel={(option) => option.label}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip
                      variant="outlined"
                      label={option.label}
                      {...getTagProps({ index })}
                      key={option.value}
                    />
                  ))
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Sid"
                    placeholder="Select Stores"
                  />
                )}
                disabled={isDeal}
              />

              {isMessage && (
                <Autocomplete
                  multiple
                  size="small"
                  className="w-[50%]"
                  id="category"
                  options={[
                    { label: "Select All", value: "all" },
                    ...categories,
                  ]}
                  disableCloseOnSelect
                  value={selectedCategories}
                  onChange={(event, newValue) => {
                    const isSelectAllSelected = newValue.some(
                      (option) => option.value === "all"
                    );

                    if (isSelectAllSelected) {
                      const allSelected =
                        selectedCategories.length < categories.length;

                      const finalSelection = allSelected ? categories : [];
                      setSelectedCategories(finalSelection);
                      setCreateData({
                        ...CreateData,
                        category: finalSelection.map((option) => option.value),
                      });
                    } else {
                      setSelectedCategories(newValue);
                      setCreateData({
                        ...CreateData,
                        category: newValue.map((option) => option.value),
                      });
                    }
                  }}
                  getOptionLabel={(option) => option.label}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        variant="outlined"
                        label={option.label}
                        {...getTagProps({ index })}
                        key={option.value}
                      />
                    ))
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Category"
                      placeholder="Select Categories"
                      className="input-grow"
                    />
                  )}
                />
              )}

              {/* <CustomInput
              label="Sid"
              name="sid"
              className="input-grow"
              value={CreateData.sid}
              disabled={isDeal}
            /> */}
            </div>
            {isDeal && (
              <div className="form-row">
                <CustomInput
                  label="Title"
                  name="title"
                  className="input-grow"
                  value={CreateData.title}
                  handelChange={handelChange}
                />
              </div>
            )}
            <div className="form-row md-flex-row">
              <CustomInput
                label="Imgurl"
                className="input-grow"
                value={CreateData.imgurl}
                name="imgurl"
                // disabled={isDeal}
                handelChange={handelChange}
              />
              <CustomImageShow link={CreateData.imgurl} />
            </div>
            {isDeal && (
              <>
                <div className="form-row md-flex-row">
                  <CustomInput
                    label="MRP"
                    className="input-grow"
                    name="mrp"
                    value={CreateData.mrp}
                    handelChange={handelChange}
                  />
                  <CustomInput
                    label="Latest Price"
                    className="input-grow"
                    value={CreateData.latestPrice}
                    name="latestPrice"
                    handelChange={handelChange}
                  />
                </div>

                <div className="form-row md-flex-row">
                  <CustomInput
                    label="In Stock"
                    className="input-grow md-half-width"
                    name="inStock"
                    value={CreateData?.inStock}
                    handelChange={handelChange}
                    optionValue={true}
                    withButton={true}
                    activeOptions={activeOptions}
                  />
                  <CustomInput
                    label="Color"
                    className="input-grow md-half-width"
                    name="color"
                    value={CreateData?.color}
                    handelChange={handelChange}
                  />
                </div>

                <div className="form-row md-flex-row">
                  <Autocomplete
                    disabled={isDeal}
                    multiple
                    size="small"
                    className="w-[50%]"
                    id="category"
                    options={categories}
                    disableCloseOnSelect
                    value={selectedCategories}
                    onChange={(event, newValue) => {
                      setSelectedCategories(newValue);
                      setCreateData({
                        ...CreateData,
                        category: newValue.map((option) => option.value),
                      });
                    }}
                    getOptionLabel={(option) => option.label}
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => (
                        <Chip
                          variant="outlined"
                          label={option.label}
                          {...getTagProps({ index })}
                          key={option.value}
                        />
                      ))
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Category"
                        placeholder="Select Categories"
                        className="input-grow"
                        disabled={isDeal}
                      />
                    )}
                  />

                  <CustomInput
                    label="Sub Category"
                    className="input-grow"
                    value={CreateData.sub_category}
                    name="sub_category"
                    handelChange={handelChange}
                  />
                </div>
                <div className="form-row md-flex-row">
                  <CustomInput
                    label="Brand"
                    className="input-grow"
                    value={CreateData.brand}
                    name="brand"
                    handelChange={handelChange}
                  />
                  <CustomInput
                    label="Affiliate Link"
                    className="input-grow"
                    value={CreateData.aff_url}
                    name="aff_url"
                    handelChange={handelChange}
                  />
                </div>
                <div className="form-row md-flex-row">
                  <CustomInput
                    label="Deal Type"
                    className="input-grow md-half-width"
                    name="deal_type_filter"
                    value={CreateData?.deal_type_filter}
                    handelChange={handelChange}
                    optionValue={true}
                    withButton={true}
                    activeOptions={DealOptions}
                  />
                  {(CreateData?.deal_type_filter === 2 ||
                    CreateData?.deal_type_filter === 3) && (
                    <CustomInput
                      label="Priority"
                      className="input-grow"
                      value={CreateData.priority}
                      name="priority"
                      handelChange={handelChange}
                    />
                  )}
                </div>
                <div className="form-row md-flex-row">
                  <CustomInput
                    label="IsExpired"
                    className="input-grow md-half-width"
                    name="isExpired"
                    value={CreateData?.isExpired}
                    handelChange={handelChange}
                    optionValue={true}
                    withButton={true}
                    activeOptions={activeOptions}
                  />
                  <></>
                </div>
              </>
            )}
          </div>
          <div className="w-full form-row md-flex-col">
            {/* <CustomInput
            label="Text"
            className="input-grow"
            value={CreateData.text}
            multiline={true}
            maxRows={4}
            name="text"
            handelChange={handelChange}
          /> */}
            <label className="block mb-2 font-semibold text-gray-700">
              Custom Message
            </label>
            <ReactQuill
              className="w-full mb-6 custom-quill"
              theme="snow"
              value={CreateData?.text}
              onChange={handleQuillChange}
              onFocus={() => setIsQuillFocused(true)}
              onBlur={() => setIsQuillFocused(false)}
            />
          </div>

          {isDeal && (
            <div className="mt-5">
              <LineChart graphData={graph_data} />
            </div>
          )}

          <div
            className=""
            style={{
              marginTop: "45px",
              marginBottom: "15px",
              gap: "16px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            {/* <CustomButton
            value="Telegram"
            id="telegram"
            className=""
            variant="outlined"
            href="https://chatgpt.com/"
            target="_blank"
            icon={TelegramIcon}
          />
          <CustomButton
            value="Deals App"
            id="dealsApp"
            handleClick={sendDealsApp}
            className=""
            variant="outlined"
            href="https://chatgpt.com/"
            target="_blank"
            icon={PhoneAndroidIcon}
          /> */}
            <CustomButton
              value={` ${!rowData ? "Save" : "Update"} ${
                isDeal ? "Deal" : "Message"
              } `}
              id="save"
              className=""
              variant="contained"
              disabled={isQuillFocused}
              handleClick={() => {
                saveToDb(false);
              }}
            />

            <CustomButton
              value={`Send ${isDeal ? "Deal" : "Message"} Notification `}
              id="sendAgain"
              className=""
              variant="contained"
              disabled={isQuillFocused}
              handleClick={() => {
                saveToDb(true);
              }}
            />

            {/* <ActiveButton
              checked={!isSent_app}
              name={"isSent_app"}
              setActive={setIsSent_app}
              label={"Send Again"}
            /> */}
          </div>
        </Paper>
      </div>
    );
  }
);

export default CreateForm;
